// // // eslint-disable-next-line camelcase
// __webpack_public_path__ = MultiContent.publicPath;
// // __webpack_require__.p =

// eslint-disable-next-line camelcase
__webpack_public_path__ = window.multicontentPublicPath
